import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../api';

const PAGE_SIZES = [10, 25, 50];

export default function DevicesPage() {
  const [users, setUsers]           = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 10, totalPages: 1 });
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch]         = useState('');
  const searchTimer                 = useRef(null);

  const fetchUsers = useCallback(async (page = 1, limit = 10, q = '') => {
    try {
      const { data } = await api.get('/admin/devices', { params: { page, limit, search: q } });
      setUsers(data.data);
      setPagination(data.pagination);
    } catch {}
  }, []);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchInput(val);
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      setSearch(val);
      fetchUsers(1, pagination.limit, val);
    }, 400);
  };

  const goToPage    = (p) => fetchUsers(p, pagination.limit, search);
  const changeLimit = (l) => { fetchUsers(1, l, search); };
  

  const { page, totalPages, total, limit } = pagination;
  const startRow = total === 0 ? 0 : (page - 1) * limit + 1;
  const endRow   = Math.min(page * limit, total);
  const pageNums = [];
  for (let i = Math.max(1, page - 2); i <= Math.min(totalPages, page + 2); i++) pageNums.push(i);

  return (
    <div>
      <div className="table-card">
        {/* Toolbar */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span className="card-title"><img src="/menu-bar-icon/device-detail.png" alt="Device" />Devices</span>
            <span style={{ fontSize: 13, color: '#718096' }}>{total} total</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={us.label}>Show</span>
              <select style={{ ...us.input, padding: '7px 10px', cursor: 'pointer' }}
                value={limit} onChange={(e) => changeLimit(Number(e.target.value))}>
                {PAGE_SIZES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ position: 'relative' }}>
              <span style={us.searchIcon}>🔍</span>
              <input
                style={{ ...us.input, paddingLeft: 30, width: 220 }}
                placeholder="Search name or email..."
                value={searchInput}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="table-wrap">
  <table className="data-table">
    <thead>
      <tr>
        <th>#</th>
        <th>User</th>
        <th>Email</th>
        <th>Device ID</th>
        <th>Number of Cores</th>
        <th>Device Name</th>
        <th>Device User</th>
        <th>Product Name</th>
        <th>Edition ID</th>
        <th>System Memory</th>
        <th>App Version</th>
      </tr>
    </thead>

    <tbody>
      {users.length === 0 && (
        <tr>
          <td
            colSpan={12}
            style={{
              textAlign: 'center',
              color: '#a0aec0',
              padding: 32
            }}
          >
            {searchInput
              ? 'No devices match your search'
              : 'No devices found'}
          </td>
        </tr>
      )}

      {users.map((device, i) => (
        <tr key={device.device_id || i}
        >

          {/* Serial Number */}
          <td>{startRow + i}</td>

          {/* User Name */}
          <td>
            {device.user?.name || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Email */}
          <td>
            {device.user?.email || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Device ID */}
          <td style={{ fontSize: 12, color: '#718096' }}>
            {device.device_id || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Number of Cores */}
          <td>
            {device.number_of_cores ?? (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Computer Name */}
          <td>
            {device.computer_name || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Windows User Name */}
          <td>
            {device.user_name || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Product Name */}
          <td>
            {device.product_name || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* Edition ID */}
          <td>
            {device.edition_id || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>

          {/* System Memory */}
          <td>
            {device.system_memory
              ? `${device.system_memory} MB`
              : <span style={{ color: '#a0aec0' }}>—</span>}
          </td>

          {/* App Version */}
          <td>
            {device.appVersion || (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

        {/* Pagination */}
        {totalPages > 0 && (
          <div style={us.paginationWrap}>
            <span style={us.pageInfo}>Showing {startRow}–{endRow} of {total}</span>
            <div style={us.pageButtons}>
              <button style={us.pageBtn} disabled={page === 1} onClick={() => goToPage(1)}>«</button>
              <button style={us.pageBtn} disabled={page === 1} onClick={() => goToPage(page - 1)}>‹</button>
              {pageNums.map((n) => (
                <button key={n} style={{ ...us.pageBtn, ...(n === page ? us.pageBtnActive : {}) }}
                  onClick={() => goToPage(n)}>{n}</button>
              ))}
              <button style={us.pageBtn} disabled={page === totalPages} onClick={() => goToPage(page + 1)}>›</button>
              <button style={us.pageBtn} disabled={page === totalPages} onClick={() => goToPage(totalPages)}>»</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const us = {
  label:         { fontSize: 13, color: '#4a5568', marginBottom: 5, fontWeight: 500, display: 'block' },
  input:         { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14, outline: 'none' },
  searchIcon:    { position: 'absolute', left: 9, top: '50%', transform: 'translateY(-50%)', fontSize: 13, pointerEvents: 'none' },
  selectedBadge: { background: '#dbeafe', color: '#1d4ed8', padding: '3px 10px', borderRadius: 12, fontSize: 13, fontWeight: 600 },
  notifBtn:      { padding: '8px 18px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 500 },
  singleNotifBtn:{ padding: '5px 12px', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', fontSize: 12 },

  paginationWrap: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginTop: 16, paddingTop: 14, borderTop: '1px solid #e2e8f0' },
  pageInfo:       { fontSize: 13, color: '#718096' },
  pageButtons:    { display: 'flex', gap: 4 },
  pageBtn:        { minWidth: 34, height: 34, padding: '0 10px', border: '1px solid #e2e8f0', background: '#fff', borderRadius: 5, cursor: 'pointer', fontSize: 13, color: '#4a5568' },
  pageBtnActive:  { background: '#2563eb', color: '#fff', borderColor: '#2563eb', fontWeight: 600 },

  backdrop:      { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modalBox:      { background: '#fff', borderRadius: 10, width: '100%', maxWidth: 500, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', maxHeight: '90vh', overflowY: 'auto' },
  modalHeader:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, background: '#fff', zIndex: 1 },
  modalTitle:    { fontSize: 16, fontWeight: 600, color: '#2d3748' },
  closeBtn:      { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#718096', lineHeight: 1 },
  modalBody:     { padding: '20px' },
  fieldRow:      { marginBottom: 16 },
  recipientsBox: { display: 'flex', flexWrap: 'wrap', gap: 6, padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 6, minHeight: 42, background: '#f8fafc' },
  recipientTag:  { display: 'flex', alignItems: 'center', gap: 4, background: '#dbeafe', color: '#1d4ed8', padding: '3px 8px', borderRadius: 12, fontSize: 12, fontWeight: 500 },
  tagRemove:     { background: 'none', border: 'none', color: '#1d4ed8', cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: 0 },
  cancelBtn:     { padding: '8px 20px', background: '#e2e8f0', color: '#4a5568', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 },
  sendBtn:       { padding: '8px 28px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 500 },
};
